import ordersApi from "@/api/orders/client";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

const useCollectionExchangeFees = (collectionId: string) => {
  const { data: collectionFeeData } = useQuery({
    queryKey: ["collectionFeeData", collectionId],
    queryFn: async () =>
      await ordersApi.calculateCollectionExchangeFee(collectionId),
  });

  const collectionExchangeFeeData = useMemo(() => {
    if (!collectionFeeData) return;

    return {
      royaltiesRecipient: collectionFeeData.royaltiesRecipient,
      rawRoyaltiesFee: +collectionFeeData?.royaltiesFee,
      royaltiesFee: +collectionFeeData?.royaltiesFee / 100,
      rawMakerFee: collectionFeeData?.makerFee,
      makerFee: collectionFeeData?.makerFee / 100,
      rawTakerFee: collectionFeeData?.takerFee,
      takerFee: collectionFeeData?.takerFee / 100,
    };
  }, [collectionFeeData]);

  return collectionExchangeFeeData;
};

export default useCollectionExchangeFees;
